import React, { useState, useEffect } from 'react';
import {
  Typography,
  Select,
  Card,
  Switch,
  Col,
  Button,
  Input,
  message,
} from 'antd';
import { withRouter } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setUserTeamSync, updateUserTeamSyncs } from '../../skills_action';
import axios from 'axios';
const { Text, Paragraph } = Typography;
const { Option } = Select;
const { Meta } = Card;
const jiraEvent = [
  {
    // label: "Assigned to me",
    label: 'Issue is updated',
    value: 'jira:issue_updated',
  },
  {
    label: 'Comment is added or updated',
    value: 'comment_created_updated',
  },
];

const JiraActivityLogFilter = (props) => {
  const dispatch = useDispatch();
  const [showFilters, setShowFilters] = useState(true);
  const [jiraEvents, setJiraEvents] = useState([
    'jira:issue_updated',
    'comment_created_updated',
  ]);
  const [filteredFields, setFieldsFilterValues] = useState([]);
  const [fields, setFields] = useState([]);
  const [jql, setJql] = useState('');
  const [filtersChanged, setFiltersChanged] = useState(false);
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state.common_reducer.user);
  const [showEventsError, setShowEventsError] = useState(false);
  const { teamsync } = props;
  const getFields = async () => {
    try {
      let res = await axios.get(
        `/bot/api/w/${props.match.params.wId}/jira/${props.match.params.skill_id}/user/${user._id}/field`
      );
      if (res.data.success) setFields(res.data.items);
    } catch (error) {}
  };
  useEffect(() => {
    getFields();
    if (teamsync && teamsync.jiraActivityFilters) {
      setShowFilters(teamsync.jiraActivityFilters.enabled);
      setJiraEvents(teamsync.jiraActivityFilters.jiraEvents || []);
      setFieldsFilterValues(teamsync.jiraActivityFilters.filteredFields || []);
      setJql(teamsync.jiraActivityFilters.jql || '');
    } else {
      setShowFilters(false);
    }
  }, []);
  const onSave = async () => {
    try {
      if (showFilters && jiraEvents.length === 0) {
        return setShowEventsError(true);
      }
      setLoading(true);

      const updateActivityLog = await axios.post(
        `/bot/api/w/${props.match.params.wId}/teamSync/${teamsync._id}/updatejiraactivityfilters`,
        { enabled: showFilters, jiraEvents, jql, filteredFields }
      );

      if (updateActivityLog.data.success) {
        message.success('Saved successfully');
        dispatch(setUserTeamSync(updateActivityLog.data.ts));
        dispatch(updateUserTeamSyncs(updateActivityLog.data.ts));
        setFiltersChanged(false);
      } else {
        message.error(
          updateActivityLog.data.message &&
            updateActivityLog.data.message.message
            ? updateActivityLog.data.message.message
            : JSON.stringify(updateActivityLog.data.message)
        );
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const onCancel = () => {
    setFiltersChanged(false);
    setJiraEvents(teamsync.jiraActivityFilters.jiraEvents || []);
    setFieldsFilterValues(teamsync.jiraActivityFilters.filteredFields || []);
    setJql(teamsync.jiraActivityFilters.jql || '');
    setShowFilters(teamsync.jiraActivityFilters.enabled);
  };

  const onjiraEventChange = (values) => {
    if (values && values.length > 0 && showEventsError) {
      setShowEventsError(false);
    }
    setJiraEvents(values);
    setFiltersChanged(true);
  };
  const onJqlChange = (event) => {
    setJql(event.target.value);
    setFiltersChanged(true);
  };
  return (
    <Col span={24}>
      <Card
        width='100%'
        title='Jira Activities Filter'
        extra={
          <Switch
            checked={showFilters}
            onClick={(value) => {
              setShowFilters(value);
              setFiltersChanged(true);
            }}
          />
        }
      >
        <Card style={{ marginBottom: 16 }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              // backgroundColor: '#efefef',
            }}
          >
            <div
              style={{
                marginBottom: 16,
              }}
            >
              <Text strong type='secondary'>
                Show only these activities from Jira
              </Text>
            </div>
            {showEventsError && (
              <span style={{ color: 'red' }}>Select atleast one activity</span>
            )}
            <Select
              disabled={!showFilters}
              name='jiraEvents'
              required
              style={{ width: 600 }}
              value={jiraEvents}
              placeholder='Defaults to all updates. Click to choose.'
              onChange={onjiraEventChange}
              mode='multiple'
            >
              {jiraEvent.map((event, i) => (
                <Option key={i} value={event.value}>
                  {event.label}
                </Option>
              ))}
            </Select>

            {jiraEvents.find((e) => e === 'jira:issue_updated') && (
              <div style={{ marginBottom: 16, marginTop: 10 }}>
                <div>
                  <Text type='secondary'>
                    and only when these fields are updated
                  </Text>
                </div>
                <div>
                  <Select
                    disabled={!showFilters}
                    name='fieldsFilter'
                    style={{ width: 600 }}
                    value={filteredFields}
                    placeholder='Defaults to all updates. Click to choose.'
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(fieldsValues) => {
                      setFieldsFilterValues(fieldsValues);
                      setFiltersChanged(true);
                    }}
                    mode='multiple'
                  >
                    {fields
                      .filter((f) => f.id !== 'comment')
                      .map((event, i) => (
                        <Option key={event.key} value={event.id}>
                          {event.name}
                        </Option>
                      ))}
                  </Select>
                </div>
              </div>
            )}
          </div>
        </Card>

        <Card style={{ marginBottom: 16 }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              // backgroundColor: '#efefef',
            }}
          >
            <div
              style={{
                marginBottom: 16,
              }}
            >
              <Text strong type='secondary'>
                Show only these issues from Jira
              </Text>
            </div>

            <Input
              disabled={!showFilters}
              name='jql'
              value={jql}
              placeholder='write JQL query here'
              onChange={onJqlChange}
              style={{ width: 600 }}
            />
          </div>
        </Card>
        <Button
          style={{ marginRight: '10px' }}
          type='primary'
          onClick={onSave}
          loading={loading}
          disabled={!filtersChanged}
        >
          Save
        </Button>

        <Button onClick={onCancel} hidden={!filtersChanged}>
          Cancel
        </Button>
      </Card>
    </Col>
  );
};
export default withRouter(JiraActivityLogFilter);
